import { apolloClient } from "../../../plugins/vue-apollo.js";

import { doMutation } from "../../core-module/util/graphqlHelper";

const updateGetTrainingRegistrationCache = ({
  trainingRegistrationId,
  trainingAttendance,
}) => {
  try {
    if (trainingRegistrationId && trainingAttendance) {
      const cacheKey = {
        query: require("../api/query/getTrainingRegistration.gql"),
        variables: { id: trainingRegistrationId },
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData && cachedData.getTrainingRegistration) {
        cachedData.getTrainingRegistration.trainingAttendance =
          trainingAttendance;

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    console.log(
      "createOrUpdateTrainingAttendance.updateGetTrainingRegistrationCache:exception:",
      e.message
    );
  }
};

export const createOrUpdateTrainingAttendance = input => {
  const mutation = require("../api/mutation/createOrUpdateTrainingAttendance.gql");
  const variables = { input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetTrainingRegistrationCache({
        trainingRegistrationId: input.trainingRegistrationId,
        trainingAttendance: data.createOrUpdateTrainingAttendance,
      });

      return { data: data.createOrUpdateTrainingAttendance };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
